import { withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00489504")

_pushScopeId("data-v-00489504")
const _hoisted_1 = {
  class: "fixed z-50 inset-0 overflow-y-auto post-share-modal",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "\n        flex\n        items-center\n        justify-center\n        min-h-screen\n        pt-4\n        px-4\n        text-center\n        sm:block\n        sm:p-0\n        relative\n      " }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_4 = { class: "\n          inline-block\n          align-bottom\n          bg-white\n          text-left\n          shadow-xl\n          transform\n          transition-all\n          sm:my-8\n          sm:align-middle\n          sm:max-w-md\n          sm:w-full\n        " }
const _hoisted_5 = { class: "bg-amff-teal px-7 md:px-14 relative" }
const _hoisted_6 = { class: "fill-post-image relative" }
const _hoisted_7 = { class: "bg-white px-7 md:px-14 py-5 md:py-10 text-amff-dark-gray" }
const _hoisted_8 = { class: "text-3xl text-center font-bold mb-8" }
const _hoisted_9 = {
  key: 0,
  class: "mb-8 text-center"
}
const _hoisted_10 = {
  key: 1,
  class: "flex justify-center mb-10"
}
const _hoisted_11 = { class: "\n                  w-16\n                  h-16\n                  rounded-full\n                  cursor-pointer\n                  relative\n                  overflow-hidden\n                  flex\n                  items-center\n                  justify-center\n                  lg:transform\n                  lg:transition-transform\n                  lg:hover:scale-105\n                " }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "bg-amff-light-teal absolute w-full h-full opacity-25" }, null, -1)
const _hoisted_13 = { class: "\n                  w-16\n                  h-16\n                  rounded-full\n                  cursor-pointer\n                  relative\n                  overflow-hidden\n                  flex\n                  items-center\n                  justify-center\n                  lg:transform\n                  lg:transition-transform\n                  lg:hover:scale-105\n                " }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "bg-amff-light-teal absolute w-full h-full opacity-25" }, null, -1)
const _hoisted_15 = { class: "text-lg font-light mb-3" }
const _hoisted_16 = { class: "relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CloseIcon = _resolveComponent("CloseIcon")
  const _component_TwitterIcon = _resolveComponent("TwitterIcon")
  const _component_LinkShare = _resolveComponent("LinkShare")
  const _component_FacebookIcon = _resolveComponent("FacebookIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "fixed inset-0 bg-black bg-opacity-75 transition-opacity",
        "aria-hidden": "true",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => _ctx.$emit('update:isShareModalOpen', false), ["self"]))
      }),
      _createVNode("button", {
        type: "button",
        class: "\n          absolute\n          right-5\n          top-5\n          w-8\n          h-8\n          cursor-pointer\n          visible\n          md:hidden\n          text-amff-white\n        ",
        onClick: _cache[2] || (_cache[2] = () => _ctx.$emit('update:isShareModalOpen', false))
      }, [
        _createVNode(_component_CloseIcon, { fill: "currentColor" })
      ]),
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = () => _ctx.$emit('update:isShareModalOpen', false)),
            class: "\n              absolute\n              right-2\n              top-2\n              w-6\n              h-6\n              cursor-pointer\n              hidden\n              md:block\n              text-amff-black\n              hover:text-amff-gray\n            "
          }, [
            _createVNode(_component_CloseIcon, { fill: "currentColor" })
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("img", {
              src: _ctx.image,
              class: ["\n                w-full\n                h-full\n                -top-6\n                md:-top-11\n                shadow-lg\n                absolute\n                object-cover\n                transition\n                duration-200\n                ease-in-out\n              ", { 'opacity-0': !_ctx.showImage }],
              onLoad: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showImage = true))
            }, null, 42, ["src"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.title), 1),
          (!_ctx.nativeShareFailed && _ctx.isSupportedShare)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("button", {
                  class: "border-2 mx-auto text-2xl p-3",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.startShare && _ctx.startShare(...args)))
                }, _toDisplayString(_ctx.$t("actions.share")), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_LinkShare, {
                  platform: "twitter",
                  data: _ctx.shareData,
                  class: "mr-8"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_TwitterIcon, {
                        class: "w-6 h-6",
                        fill: "currentColor"
                      }),
                      _hoisted_12
                    ])
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_LinkShare, {
                  platform: "facebook",
                  data: _ctx.shareData
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_FacebookIcon, {
                        class: "w-6 h-6",
                        fill: "currentColor"
                      }),
                      _hoisted_14
                    ])
                  ]),
                  _: 1
                }, 8, ["data"])
              ])),
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("post.or_copy_link")), 1),
          _createVNode("div", _hoisted_16, [
            _createVNode("input", {
              class: ["\n                border border-black\n                text-base\n                font-light\n                py-1\n                px-4\n                w-full\n                pr-20\n              ", { 'pr-24': _ctx.copied }],
              type: "text",
              readonly: "",
              value: _ctx.url
            }, null, 10, ["value"]),
            (_ctx.isSupportedClipboard)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: ["\n                absolute\n                right-0\n                mt-1\n                py-1\n                px-4\n                text-sm\n                uppercase\n                outline-none\n                font-display\n                lg:hover:text-amff-gray\n              ", { 'text-green-600': _ctx.copied }],
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copy(_ctx.url)))
                }, _toDisplayString(_ctx.copied ? _ctx.$t("actions.copied") : _ctx.$t("actions.copy")), 3))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
})